import { SupplierType } from '../pages/dataInputs/suppliers/types';
import { camelCaseToDash } from './camelCaseToDash';

export const formatSupplierData = (data: SupplierType[]) => {
  return data?.map((record) => {
    return {
      ...record,
      sourcingStatus: camelCaseToDash(record.sourcingStatus ?? ''),
      availableAlternatives:
        Number(record.availableAlternatives) === 2
          ? '2+'
          : record.availableAlternatives.toString(),
      qualifiedAlternatives:
        Number(record.qualifiedAlternatives) === 2
          ? '2+'
          : record.qualifiedAlternatives.toString(),
    };
  });
};